import { render, staticRenderFns } from "./Duplicates.vue?vue&type=template&id=45270658&scoped=true"
import script from "./Duplicates.vue?vue&type=script&lang=js"
export * from "./Duplicates.vue?vue&type=script&lang=js"
import style0 from "./Duplicates.vue?vue&type=style&index=0&id=45270658&prod&scoped=true&lang=scss"
import style1 from "./Duplicates.vue?vue&type=style&index=1&id=45270658&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45270658",
  null
  
)

export default component.exports